import {
  MOCKAROO_FIELDS_BY_CATEGORY,
  CATEGORY_LABELS,
  type MockarooCategory,
} from '../lib/mockaroo-fields';

const ORDER: MockarooCategory[] = [
  'telecom',
  'identity',
  'names',
  'contact',
  'location',
  'business',
  'numbers',
  'datetime',
  'text',
  'other',
];

/**
 * Categorised <select> of curated Mockaroo field types. Accepts any
 * string (including ones not in the curated list) so power users can
 * use Mockaroo types we haven't enumerated yet — those flow through as
 * a synthetic "(custom)" group at the top of the list.
 */
export function MockarooFieldSelect({
  value,
  onChange,
  ariaLabel,
}: {
  value: string;
  onChange: (next: string) => void;
  ariaLabel?: string;
}) {
  const knownTypes = new Set(Object.values(MOCKAROO_FIELDS_BY_CATEGORY).flat().map((f) => f.type));
  const isCustom = value && !knownTypes.has(value);

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={ariaLabel}
      style={{ minWidth: 180 }}
    >
      {!value && <option value="">Select type…</option>}
      {isCustom && (
        <optgroup label="Custom">
          <option value={value}>{value} (free-form)</option>
        </optgroup>
      )}
      {ORDER.map((cat) => {
        const fields = MOCKAROO_FIELDS_BY_CATEGORY[cat] || [];
        if (fields.length === 0) return null;
        return (
          <optgroup key={cat} label={CATEGORY_LABELS[cat]}>
            {fields.map((f) => (
              <option key={f.type} value={f.type} title={f.description}>
                {f.label}
              </option>
            ))}
          </optgroup>
        );
      })}
    </select>
  );
}
